import service from './service'
class APIList {
  /**
   * @desc 获取数据列表
   */
  constructor() {
    this.prefix = '/manage-object'
    this.prefixs = '/manage-model'
    this.prefixd = '/mqtt-to-kafka'
    this.prefixdesign = '/manage-design'
  }
  getHistogram(data) {
    return service.post(this.prefix + '/chart/getHistogram', data)
  }
  getLeftList() {
    return service.get(this.prefix + '/project/getTree')
  }
  getTree(type, id) {
    return service.get(this.prefix + '/project/getTree?id=' + id + '&type=' + type)
  }
  getChildrenNode(id) {
    return service.get(this.prefix + '/project/getChildrenNode?id=' + id)
  }
  removePoint(id) {
    return service.get(this.prefix + '/project/deleteNode?id=' + id)
  }
  renamePoint(params) {
    return service.post(this.prefix + '/project/updateNode', params)
  }
  getRightList(id) {
    return service.get(this.prefix + '/project/getChildren?id=' + id)
  }
  getRightListByOrder(params) {
    return service.post(this.prefix + '/project/getChildrenByOrder', params)
  }
  newAddPoint(data) {
    return service.post(this.prefix + '/project/saveNode', data)
  }
  editPoint(data) {
    return service.post(this.prefix + '/project/updateNode', data)
  }
  onlineChart(data) {
    return service.post(this.prefix + '/onlineChart/getDatas', data)
  }
  getNodeEcharts(data) {
    return service.post(this.prefix + '/onlineChart/getNode', data)
  }
  checkDevice(din) {
    return service.get(
      this.prefix + '/deviceControl/deviceDetection?din=' + din
    )
  }
  getDeviceMsg(din) {
    return service.get(this.prefix + '/deviceControl/getDeviceInfo?din=' + din)
  }
  // 根据当前ID查询当前节点
  getNode(id) {
    return service.get(this.prefix + '/project/getNode?id=' + id)
  }
  // 更新web操作
  updateWeb(id) {
    return service.get(this.prefix + '/project/updateWeb?id=' + id)
  }
  updatePoint(data) {
    return service.post(this.prefix + '/deviceControl/sendMessage', data)
  }
  searchDevice(din, ip) {
    return service.get(this.prefix + '/deviceControl/getDevices?din=' + din + '&ip=' + ip)
  }
  saveDevices(data) {
    return service.post(this.prefix + '/deviceControl/saveDevices', data)
  }
  updatePointData(data) {
    return service.post(this.prefix + '/deviceControl/updatePhysicalPoint', data)
  }
  getDeviceStatus() {
    return service.get(this.prefix + '/deviceControl/getDeviceStatus')
  }
  search(params) {
    return service.post(this.prefix + '/project/search', params)
  }
  // 写入备忘录
  saveMemo(data) {
    return service.post(this.prefix + '/project/saveMemo', data)
  }
  // 获取备忘录
  getMemo(id) {
    return service.get(this.prefix + '/project/getMemo?id=' + id)
  }
  // 修改名称描述接口
  updateNameDesc(data) {
    return service.post(this.prefix + '/project/updateNameDesc', data)
  }
  // 程序下载列表接口
  orderDownList() {
    return service.post(this.prefix + '/program/getAll')
  }
  // 程序下载的接口
  orderDown(id) {
    return service.get(this.prefix + '/program/downLoad?id=' + id)
  }
  // 设备模型数据接口
  modelDown(obj) {
    return service.post(this.prefixs + '/modelAndDevice/findModel', obj)
  }
  // 新建趋势日志的接口
  trendLog(obj) {
    return service.post(this.prefix + '/project/saveNode', obj)
  }
  // 趋势日志展示接口
  trendLogShow(obj) {
    return service.post(this.prefix + '/onlineChart/getHistData', obj)
  }
  // 新建设备模型接口
  addModel(model) {
    return service.post(this.prefixs + '/model/addModel', model)
  }

  // 修改模板
  updataModel(model) {
    return service.post(this.prefixs + '/model/updModel', model)
  }
  // 删除模板
  delModel(modelId) {
    return service.get(this.prefixs + '/model/delModel?modelId=' + modelId)
  }
  // 上传图片
  upFile(file1) {
    return service.post(this.prefixs + '/imgs/upfile', file1)
  }
  // 获取所有图片
  upFiles() {
    return service.post(this.prefixs + '/model/upfiles')
  }
  // 获取模板定位数据
  modelData() {
    return service.get(this.prefixs + '/model/modelData')
  }
  // 获取图片
  getImgAll() {
    return service.get(this.prefixs + '/imgs/getImgAll')
  }
  // 删除图片
  delImg(img, id) {
    return service.get(this.prefixs + '/imgs/delImg?path1=' + img + '&imgId=' + id)
  }
  // 模糊查询
  dimLink(name) {
    return service.get(this.prefixs + '/model/mohu?name=' + name)
  }
  // 根据ID查询单个模板
  getModelById(modelId, id) {
    return service.get(this.prefixs + '/modelTree/getModelTree?modelId=' + modelId + '&id=' + id)
  }
  // echarts曲线图展示
  getAssignData(obj) {
    return service.post(this.prefix + '/onlineChart/getAssignData', obj)
  }
  // 获取所有的趋势日志
  getAllTrendLog() {
    return service.get(this.prefix + '/project/getAllTrendLog')
  }
  // 清除日志接口
  DeleteTrendLog(id) {
    return service.get(this.prefix + '/project/deleteTrendLog?Id=' + id)
  }
  // 查看单台设备是否在线
  getDeviceStatusd(id) {
    return service.get(this.prefix + '/project/getDeviceStatus?id=' + id)
  }
  // 初始化加载Tree
  getAllTree() {
    return service.get(this.prefix + '/project/getAllTree')
  }
  // 点击展开
  getNextNode(id) {
    return service.get(this.prefix + '/project/getNextNode?id=' + id)
  }
  // 趋势日志展示接口
  getPoint(id) {
    return service.get(this.prefix + '/project/getPoint?id=' + id)
  }
  // 上传文件到文件夹里面
  formUpload(file) {
    return service.post(this.prefix + '/project/formUpload', file)
  }
  // 上传的文件进行回显
  download(id) {
    return service.get(this.prefix + '/project/download?id=' + id)
  }
  // 回显
  view(id) {
    return service.get(this.prefix + '/project/view?id=' + id)
  }
  // 计
  formulaToValue(id) {
    return service.get(this.prefix + '/project/formulaToValue?id=' + id)
  }
  // 同步时间
  setTime(id) {
    return service.post(this.prefix + '/project/setTime?id=' + id)
  }
  // 删除TOPIC
  rmTopic(data) {
    return service.post(this.prefix + '/mqtt/rmTopic', data)
  }
  // 添加TOPIC
  addTopic(data) {
    return service.post(this.prefix + '/mqtt/addTopic', data)
  }
  // 查询TOPIC
  findAllTopic() {
    // return service.get(this.prefix + '/mqtt/findAll')
  }
  // 在线人数
  getOnLineUser() {
    return service.get(this.prefix + '/project/getOnLineUser')
  }
  // 设备在线检查
  isOnline(id) {
    return service.post(this.prefix + '/project/isOnline', id)
  }
  // 对象传输加载Tree
  getAllSubDevices() {
    return service.get(this.prefix + '/project/getAllSubDevices')
  }
  // 获取趋势日志信息
  getPoints(id) {
    return service.get(this.prefix + '/project/getPoint?id=' + id)
  }
  // 复制粘贴
  copyPaste(startId, endId) {
    return service.get('/manage-object/project/copyPaste?startId=' + startId + '&endId=' + endId)
  }
  // 获取所有标签
  findAllPointLabel() {
    return service.get(this.prefix + '/project/findAllLabel')
  }
  // 创建标签
  savePointLabel(pointLabel) {
    return service.post(this.prefix + '/project/saveLabel', pointLabel)
  }
  // 删除标签
  deletePointLabel(ids) {
    return service.delete(this.prefix + '/project/deleteLabels', ids)
  }
  // 修改标签
  updatePointLabel(pointLabel) {
    return service.post(this.prefix + '/project/saveLabel', pointLabel)
  }
  // 查询所有标签并标记资源绑定状态
  findAllLabelWithBoundStatus(resourceId) {
    return service.get(this.prefix + '/project/findAllLabelWithBoundStatus?resourceId=' + resourceId)
  }
  // 资源绑定解绑标签
  updateLabelsForResource(data) {
    return service.post(this.prefix + '/project/updateLabelsForResource', data)
  }
  // 摄像头
  camera(data) {
    return service.post('/camera-server/camera/cameras', data)
  }
  // 创建数据接口
  createTemplate(data) {
    return service.post('/resources/saveInterfaceTemplate', data)
  }
  // 删除数据接口
  deleteTemplate(id) {
    return service.delete('/resources/delete?id=' + id)
  }
  // 修改数据接口
  updateTemplate(data) {
    return service.put('/resources/update', data)
  }
  // 获取所有接口数据
  findTemplate() {
    return service.get('/resources/find')
  }
  // 设计工具加载树接口
  getDesignAllTree() {
    return service.get(this.prefixdesign + '/project/getAllTree')
  }
  // 设计工具添加项目
  designSaveNode(data) {
    return service.post(this.prefixdesign + '/project/saveNode', data)
  }
  // excal表格下载
  exportAttendData(data) {
    return service.post(this.prefix + '/project/exportAttendData/export', data)
  }
  // 获取私有接口数据
  interfaceGetData(data) {
    return service.post(this.prefix + '/interface/getData', data)
  }
  // 获公共取接口数据
  getPublicData(data) {
    return service.post(this.prefix + '/interface/getPublicData', data)
  }
  // 获公共取接口数据
  getPublicData2(data) {
    return service.post(this.prefix + '/interface/getPublicData2', data)
  }
  // 修改数据
  updatePhysicalPoint(data) {
    return service.post(this.prefix + '/deviceControl/updatePhysicalPoint', data)
  }
  // 剪切
  getMove(data) {
    return service.post(this.prefix + '/project/move', data)
  }
  // 查询数据接口ID/name
  interfaceFind() {
    return service.get(this.prefix + '/interface/find')
  }
  // 单个icu设备事件记录
  findDeviceLogAndAlarm(data) {
    return service.post(this.prefix + '/alarmEvent/findDeviceLogAndAlarm', data)
  }
  // 获取视频token
  tokenYingshi() {
    return service.get(this.prefix + '/ezviz/token')
  }
  // 使ICU连接到平台
  deviceLink(data) {
    return service.post(this.prefix + '/project/deviceLink', data)
  }
  // 使ICU和平台断开连接
  deviceUnlink(data) {
    return service.post(this.prefix + '/project/deviceUnlink', data)
  }
  // 新ICU和平台断开连接
  deviceUnlinkIcu() {
    return service.get('/manage-icu/client/unlink')
  }
  // 升级icu
  upgradeIcu(data) {
    return service.post('/manage-icu/client/upgradeICU', data)
  }
  // 升级Boot
  upgradeBoot(data) {
    return service.post('/manage-icu/client/upgradeBoot', data)
  }
  // 更新web
  upgReset(id) {
    return service.get('/manage-object/deviceControl/reset?id=' + id)
  }

  // 取消更新
  icuCancel(din) {
    return service.delete('/manage-icu/client/cancel?din=' + din)
  }

  // 根据设备获取场景配置文件
  icuSceneConfig(sn) {
    return service.get('/manage-icu/client/sceneConfig?sn=' + sn)
  }


  // 根据设备和文件类型获取升级文件
  icuFile(sn, type) {
    return service.get('/manage-icu/client/file?sn=' + sn + '&type=' + type)
  }

  // 连接到支持服务平台
  serviceLink(sn) {
    return service.get('/manage-icu/client/link?sn=' + sn)
  }
  // 断开支持服务平台连接
  serviceUnLink() {
    return service.get('/manage-icu/client/unlink')
  }

  // 登录服务平台接口
  serviceLogin() {
    return service.get(this.prefix + '/project/login')
  }

  // 查看所有场景配置文件
  allSceneConfig() {
    return service.get('/manage-icu/client/allSceneConfig')
  }

  // 设置ICU场景配置
  setSceneConfig(din, id) {
    return service.post('/manage-icu/client/setSceneConfig?din=' + din + '&id=' + id)
  }

  // 经纬度相互转化
  serviceLogin(lat, lon) {
    return service.get(this.prefix + '/project/convertToBD09?lat=' + lat + '&lon=' + lon)
  }

  // 上传更新文件
  programFile(data) {
    return service.post('manage-object/file/upload/program', data)
  }

  // 删除上传的文件
  programDelFile(id) {
    return service.get('manage-object/file/remove/program?id=' + id)
  }

  // 上传的文件列表
  programAllFile(type) {
    return service.get('manage-object/project/programFiles?type=' + type)
  }

  // 选择app确定
  programUpgradeICU(uid, din, id) {
    return service.get('manage-icu/client/upgradeICU?uid=' + uid + '&din=' + din + '&id=' + id)
  }

  // 选择boot确定
  programUpgradeBoot(uid, din, id) {
    return service.get('manage-icu/client/upgradeBoot?uid=' + uid + '&din=' + din + '&id=' + id)
  }

  // 获取下载进度条
  getProgressBar(din) {
    return service.get('manage-icu/client/getProgressBar?din=' + din)
  }
  // 批量处理
  groupControl(id, name, value) {
    return service.post('manage-object/project/groupControl?id=' + id + '&name=' + name + '&value=' + value)
  }
  // 保存功能资源接口  post
  saveFunctionResource(data) {
    return service.post('/api/user/authority/saveFunctionResource', data)
  }
  // 查询功能树接口  get
  queryFunctionTree() {
    return service.get('/api/user/authority/queryFunctionTree')
  }
  // 删除功能资源接口   post
  delFunctionResource(data) {
    return service.post('/api/user/authority/delFunctionResource', data)
  }
  // 查询数据资源接口   get
  queryDataResource() {
    return service.get('/api/user/authority/queryDataResource')
  }
  // 删除工作接口    post
  delWork(data) {
    return service.post('/api/user/job/del')
  }
  // 保存工作接口    post
  saveJob(data) {
    return service.post('/api/user/job/saveJob', data)
  }
  // 按组织查询工作接口   get
  queryByOrg(orgId) {
    return service.get('/api/user/job/queryByOrg?orgId=' + orgId)
  }
  // 保存组织接口   post
  saveUser(data) {
    return service.post('/api/user/org/save', data)
  }
  // 查询组织树接口  post
  queryTree(data) {
    return service.post('/api/user/org/queryTree', data)
  }
  // 删除组织接口   post
  delOrganization(data) {
    return service.post('/api/user/org/del', data)
  }
  // 当前用户命令功能接口  post
  currentUserFunction(data) {
    return service.post('/api/user/role/currentUserFunction', data)
  }
  // 保存角色接口   post
  saveUser(data) {
    return service.post('/api/user/role/save', data)
  }
  // 删除角色接口   post
  delUser(data) {
    return service.post('/api/user/role/del', data)
  }
  // 查询角色列表接口   get
  queryList(code, name, current, pageSize) {
    return service.get('/api/user/role/queryList?code=' + code + '&name=' + name + '&current=' + current + '&pageSize=' + pageSize)
  }
  // 给角色赋予功能资源权限接口  post
  grantFunctionResource(data) {
    return service.post('/api/user/role/grantFunctionResource', data)
  }
  // 授予角色数据权限接口   post
  grantDataAuthority(data) {
    return service.post('/api/user/role/grantDataAuthority', data)
  }
  // 查询角色拥有的功能资源集接口   get
  functionResourceList(roleId) {
    return service.get('/api/user/role/functionResourceList?roleId=' + roleId)
  }
  // 查询角色数据资源列表接口   get
  dataResourceList(roleId) {
    return service.get('/api/user/role/dataResourceList?roleId=' + roleId)
  }
  // 给用户授权接口
  grantUser(data) {
    return service.post('/api/user/role/grantUser', data)
  }
  // 给岗位绑定角色接口
  grantJob(data) {
    return service.post('/api/user/role/grantJob', data)
  }
  // 查询用户拥有的角色接口
  userRoleList(userId) {
    return service.get('/api/user/role/userRoleList?userId=' + userId)
  }
  // 查询岗位拥有的角色接口
  jobRoleList(jobId) {
    return service.get('/api/user/role/jobRoleList?jobId=' + jobId)
  }
  // 登录接口
  doLogin(data) {
    return service.post('/api/user/doLogin', data)
  }
  // 注销接口
  doLogout() {
    return service.post('/api/user/doLogout')
  }
  // 事件条件查询事件
  searchEvent(data) {
    return service.post('/manage-event/alarmEvent/searchEvent', data)
  }
  // 报警条件查询事件
  searchAlarm(data) {
    return service.post('/manage-event/alarmEvent/searchAlarm', data)
  }
  // 查询所有全景图接口
  getAllPanorama() {
    return service.get('/manage-object/panorama/selectAll')
  }
  // 添加全景图
  addPanorama(data) {
    return service.post('/manage-object/panorama/addPanorama', data)
  }
  // 添加marker点
  addMarker(data) {
    return service.post('/manage-object/panorama/addMarker', data)
  }
  // 删除marker点
  deleteMarker(data) {
    return service.delete(`/manage-object/panorama/deleteMarker?id${data}`)
  }
  /**
   * Time 2024-4-24 11:39
   * Author zhaoyipeng
   */
  // 获取实时数据
  getRealTimeData(data) {
    return service.post('/manage-object/project/getPoints', data)
  }
  // 修改数据接口
  updatePhysicalPoint2(data) {
    return service.post('/manage-object/project/updatePhysicalPoint2', data)
  }
  // icu和风机盘管数量统计
  getOnlineData(id) {
    return service.get('/manage-object/project/OnlineData?id=' + id)
  }
  // 获取每天数据
  getlodayData(data) {
    return service.get('/manage-object/project/getTodayData', data)
  }
  // 雷达盘管同步
  fanCheck(id) {
    return service.post('/manage-object/report/fanCheck?id=' + id)
  }
  //获取方波曲线
  getSquareWaveData(data) {
    return service.post('/manage-object/onlineChart/getSquareWaveData', data)
  }
  // 获取单日数据（一天秒级日志）
  getOneDayData(pointIds) {
    return service.post('/manage-object/onlineChart/getOneDayData', pointIds)
  }
  // 查询不在线设备
  offLineData() {
    return service.get('/manage-object/project/offLineData')
  }
  // 查询报告
  queryByData(date) {
    return service.post('/manage-object/report/queryByDate?date=' + date)
  }
  // 创建规则
  createRule() {
    return service.post('/manage-object/rule/save')
  }


  // 查询标签资源
  findLabelBoundResource(params) {
    return service.get('/manage-object/project/findLabelBoundResource', params)
  }
  // 根据din或者sn查询ICU是否在平台上
  queryBySn(sn, din) {
    return service.get(this.prefix + '/project/queryBySn?sn=' + sn + '&din=' + din)
  }
  // 给资源排序
  sort(data) {
    return service.post('/manage-object/project/sort', data)
  }

  getCameraList(data) {
    return service.post('/monitor/cameras/getAll', data)
  }

  // 按年月查询日历数据接口
  getCalendarData(year, month) {
    return service.get(`/manage-object/calendar/month?year=${year}&month=${month}`)
  }

  // 修改日历
  updateCalendarData(data) {
    return service.put(`/manage-object/calendar/batchUpdate`, data)
  }
}

export default new APIList()



// WEBPACK FOOTER //
// ./src/service/leftService.js